 export enum OperatorStatsCsvType {
  Counts = 'Counts',
  Duration = 'Duration',
  MinMaxAvg='MinMaxAvg'
}